import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { Copy } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import Context from '../service/Context';
import themeStyles from '../PaymentDetailsComponent.styles';
const PaymentLabelCopy = themeStyles.apply(Copy, 'PaymentLabelCopy');
const PaymentContentCopy = themeStyles.apply(Copy, 'PaymentContentCopy');
const Terms = () => {
    const { t } = useTranslation();
    const { terms, apr } = useContext(Context);
    return (_jsxs(_Fragment, { children: [_jsx(PaymentLabelCopy, { size: "extraSmall", "data-testid": "cy-payment-term-label", children: t('Shared.Common.termByMonthLabel') }), _jsx(PaymentContentCopy, { size: "regular", "data-testid": "cy-payment-term-value", children: `${terms} @ ${apr === null || apr === void 0 ? void 0 : apr.toFixed(2)}%` })] }));
};
export default Terms;
